/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequest from '../api/api.request';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import endpoints from '../../../constants/endpoints';
import { getLoanTypeAction, ILoanTypeResponse, setLoanTypeAction } from '../actions/LoanTypeAction';

function* fetchLoanType(): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.LOAN_TYPE,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: {},
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, code, message } = res as any;
        const result: ILoanTypeResponse = {
            code,
            message,
            data
        };
		yield put(setLoanTypeAction(result));
		return result;
	} catch (err) {
		return err;
	}
}

function setLoanTypeSaga({
	payload,
}: {
	payload: ILoanTypeResponse;
}): ILoanTypeResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

export default function* loanTypeSaga(): Generator {
    yield takeLatest(getLoanTypeAction, fetchLoanType);
    yield takeLatest(setLoanTypeAction, setLoanTypeSaga);
}
